import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { getShopItemsStreamId } from '../../../../streams/shop';
import { getDeviationsByIds } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import {
  withOffset,
  selectors as streamSelectors,
} from '@wix/da-shared-react/pkg/Stream';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import { AppState } from '../../../../../types/store';

import { Props } from './ShopGrid';

type StateProps = Pick<
  Props,
  'streamId' | 'items' | 'hasMore' | 'isFetching' | 'isOwner'
>;
type DispatchProps = Pick<Props, 'fetchMore'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const streamId = getShopItemsStreamId(ownProps.itemType);
  return {
    streamId,
    items: getDeviationsByIds(state, streamSelectors.getItems(state, streamId)),
    hasMore: streamSelectors.hasMore(state, streamId),
    isFetching: streamSelectors.isFetching(state, streamId),
    isOwner: isCurrentUserProfileOwner(state),
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  fetchMore: () =>
    dispatch(withOffset.actions.fetch(getShopItemsStreamId(ownProps.itemType))),
});

export default connect(mapStateToProps, mapDispatchToProps);
